// Code rides in the URL hash so it never reaches server logs, then sits in
// sessionStorage so it survives a full reload of this tab.
const STORAGE_KEY = 'vesyl.authHandoffCode'

export function captureAuthHandoffCode() {
  if (window.location.pathname !== '/auth/handoff') return

  const fromHash = new URLSearchParams(window.location.hash.slice(1)).get('code')
  if (fromHash) {
    try {
      sessionStorage.setItem(STORAGE_KEY, fromHash)
    } catch {
      // Private mode can throw; the route then reads null and shows the failed state.
    }
  }
  if (window.location.hash) {
    window.history.replaceState(
      window.history.state,
      '',
      `${window.location.pathname}${window.location.search}`,
    )
  }
}

export function readAuthHandoffCode() {
  try {
    return sessionStorage.getItem(STORAGE_KEY)
  } catch {
    return null
  }
}

export function clearAuthHandoffCode() {
  try {
    sessionStorage.removeItem(STORAGE_KEY)
  } catch {}
}
